import React from "react";

const DigitalMarketing = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-center py-5">Digital Marketing</h1>
    </div>
  );
};

export default DigitalMarketing;
